<template>
	<div>
		<b-row class="float-right">
			<b-col>
				<b-button
					v-if="$hasPermission('serviceTypesCategories.add')"
					@click="newModel"
					>Nueva categoria de servicio</b-button
				>
			</b-col>
		</b-row>

		<h2>Categorias de servicio</h2>
		<hr />
		<b-form
			@submit="
				evt => {
					evt.preventDefault();
					this.$root.$emit(
						'bv::refresh::table',
						'service-types-index-list'
					);
				}
			"
		>
			<div class="row">
				<b-form-group class="col-2" label="Buscar">
					<b-form-input v-model="filters.search" type="text" />
				</b-form-group>
				<b-form-group class="col-2" label=".">
					<b-button type="submit" variant="primary">Buscar</b-button>
				</b-form-group>
			</div>
		</b-form>
		<AjaxTable
			permission-show="serviceTypesCategories.show"
			id="service-types-index-list"
			:filters="filters"
			responsive="md"
			:columns="modelColumns"
			resource="service-types-categories"
		>

			<template v-slot:cell(actions)="row">
				<div class="text-center">
					<b-button
						@click="event => editModel(row.item.id)"
						type="button"
						size="sm"
						class="mr-1"
						variant="info"
					>
						<md-icon icon="edit" />
					</b-button>
					<b-button
						v-if="$hasPermission('serviceTypesCategories.delete')"
						@click="
							event => deleteModel(row.item, row.index, event)
						"
						type="button"
						size="sm"
						class="mr-1"
						variant="danger"
					>
						<md-icon icon="delete" />
					</b-button>
				</div>
			</template>
		</AjaxTable>

		<Single
			:unableEdit="unableEdit"
			ref="single"
			:success-callback="successCallback"
		/>
	</div>
</template>

<script>
import AjaxTable from "../../helpers/AjaxTable";
import Single from "./Single";
import api from "../../../api.js";

export default {
	components: { Single, AjaxTable },
	data() {
		return {
			unableEdit: false,
			filters: {
				search: ""
			}
		};
	},
	computed: {
		modelColumns() {
			const modelColumns = [
				{ key: "id", label: "ID" },
				{ key: "code", label: "Codigo" },
				{ key: "name", label: "Nombre" },
				{ key: "status", label: "Estado" },
				{ key: "actions", label: "Acciones" }
			];
			return JSON.parse(JSON.stringify(modelColumns));
		}
	},
	created() {
	},
	methods: {
		successCallback() {
			this.$root.$emit(
						'bv::refresh::table',
						'service-types-index-list'
					);
		},
		editModel(id) {
			this.unableEdit = !this.$hasPermission("serviceTypesCategories.edit");
			this.$refs["single"].loadModel(id);
		},
		newModel() {
			this.$refs["single"].loadModel(-1);
		},
		deleteModel(item) {
			this.$root.showWarning({
				okAction: (event, setLoading, close) => {
					setLoading(true);
					api(this)
						.delete(`/service-types-categories/${item.id}`)
						.then(() => {
							this.$root.showAlert("Registro Eliminado!", {
								variant: "warning"
							});
							this.$root.auxVars.loadResourcesOpts({
								vm: this,
								resourceNames: ["serviceTypesCategories"],
								forceRefresh: true
							});
							this.successCallback();
							close();
						})
						.catch(err => {
							this.$root.handleRequestError(err);
							close();
						});
				}
			});
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["serviceTypesCategories"]
		});
	}
};
</script>

